import _sfc_main from "./indexPC.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "invite-container" }, [_vm._l(_setup.invitationFeatureDetails, function(item, index) {
    return _c("div", { key: index, staticClass: "invite-item", on: { "click": function($event) {
      return item.function();
    } } }, [_c(_setup.SvgIcon, { staticClass: "icon", attrs: { "icon": item.icon } }), _c("span", { staticClass: "invite-title" }, [_vm._v(_vm._s(_setup.t(item.text)))])], 1);
  }), _c(_setup.Contacts, { attrs: { "visible": _setup.showContacts, "contacts": _setup.contacts, "disabled-list": _setup.remoteEnteredUserList }, on: { "input": function($event) {
    _setup.showContacts = $event;
  }, "confirm": _setup.contactsConfirm } }), _c(_setup.Dialog, { attrs: { "title": _setup.t("sb invites you to join the conference", { name: _setup.userName || _setup.userId }), "modal": true, "show-close": true, "close-on-click-modal": true, "width": "540px", "append-to-body": true, "title-icon": _setup.SuccessIcon }, scopedSlots: _vm._u([{ key: "footer", fn: function() {
    return [_c("span", [_c(_setup.TuiButton, { staticClass: "dialog-button", attrs: { "size": "default" }, on: { "click": function($event) {
      return _setup.copyRoomIdAndRoomLink();
    } } }, [_vm._v(_vm._s(_setup.t("Copy the conference number and link")) + " ")])], 1)];
  }, proxy: true }]), model: { value: _setup.isShowRoomShareForm, callback: function($$v) {
    _setup.isShowRoomShareForm = $$v;
  }, expression: "isShowRoomShareForm" } }, [_c("div", { staticClass: "invite-member" }, _vm._l(_setup.inviteInfoList, function(item) {
    return _c("div", { directives: [{ name: "show", rawName: "v-show", value: item.isVisible, expression: "item.isVisible" }], key: item.title }, [_c("div", { staticClass: "invite-member-container" }, [_c("span", { staticClass: "invite-member-title" }, [_vm._v(_vm._s(_setup.t(item.title)))]), _c("span", { staticClass: "invite-member-content", attrs: { "title": item.content } }, [_vm._v(" " + _vm._s(item.content) + " ")]), item.isShowCopyIcon ? _c(_setup.SvgIcon, { staticClass: "copy", attrs: { "icon": _setup.copyIcon }, on: { "click": function($event) {
      return _setup.onCopy(item.content);
    } } }) : _vm._e()], 1)]);
  }), 0)])], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "83dd4016"
);
const indexPC = __component__.exports;
export {
  indexPC as default
};
